import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import cn from 'classnames';

import { HBox } from '../../../components/Box';
import { Checkbox } from '../../../components/Checkbox';
import { USERS_CRUD } from '../../../components/Permission/constants';
import { Permission } from '../../../components/Permission';
import { approveWebsiteUserData, disapproveWebsiteUserData, setUserProperty, updateUser } from '../actions';
import styles from './CardWebsiteLoginPermissions.module.css';
import env from '../../../env';

import { Card } from '../../../components/Card';
import { Cell, List, Row } from '../../../components/List';
import { EditSquare } from '../../../components/Icon';
import { USER_DETAILS_WEBSITE_USER_DATA_CARD } from '../constants';
import { SearchSelect } from '../../../components/SearchSelectComponent';
import ButtonComponent from '../../../containers/App/Components/Button/Button';
import { CompanySelection } from '../../Companies/components/CompanySelection';
import ModalComponent from '../../../containers/App/Components/Modal/Modal';

const Container = styled.div`
  font-size: 14px;
  align-self: stretch;

  .cell:first-child {
    text-transform: capitalize;
  }

  .icon-edit-square {
    color: #d9d9d9;
  }

  & ~ .button-row {
    display: flex;
    justify-content: end;
  }
`;

const STATE = {
  isEditUser: false,
  companySelectionModal: false,
  company: null,
};
/* eslint-disable react/prefer-stateless-function */
class WebsiteLoginPermissionsCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    USER_DETAILS_WEBSITE_USER_DATA_CARD.map(property => {
      if (this.user?.[property]) {
        this.setState({ [property]: this.user[property] });
      }
    });
  }

  get user() {
    return this.props.user;
  }

  get mainInfoFields() {
    let fields = ['company_name', 'company_place', 'name', 'surname', 'email_address'];

    if (this.props.companyDetails) {
      return fields.slice(2);
    }

    return fields;
  }

  get financialFieds() {
    let fields = [];

    fields = [
      'approved_for_website',
      'disapproved_for_website',
      'financial_price_gross_incl_btw_bpm',
      'financial_price_nett_excl_vat_bpm',
      'financial_price_b2c',
      'financial_price_b2b_incl_vat_btpm',
      'newsletters',
    ];

    return fields;
  }

  dropdown(type) {
    const vals = ['individual', 'company'];

    const options = vals.map(val => ({
      label: this.lbl(`company.property.${type}.${val}`),
      value: val,
    }));

    const value = options.find(o => o.value == this.state[type]);

    return (
      <div>
        <SearchSelect
          controlClassName={'dropdown-card'}
          options={options}
          value={value}
          onChange={pair => this.setState({ [type]: pair.value })}
        />
      </div>
    );
  }

  input(type) {
    if (type === 'company_name') {
      return (
        <div className={styles.ButtonGroupCheck}>
          <div className={styles.Input}>
            <input
              className="form-control"
              value={this.state[type]}
              onClick={() => this.setState({ companySelectionModal: true })}
            />
          </div>
        </div>
      );
    }
    return (
      <div className={styles.ButtonGroupCheck}>
        <div className={styles.Input}>
          <input
            className="form-control"
            value={this.state[type]}
            onChange={evt => this.setState({ [type]: evt.target.value })}
          />
        </div>
      </div>
    );
  }

  onSelectCompany(company) {
    const companyName = company.company_type === 'individual' ? company.fullname : company.name;
    this.setState({
      company: company,
      companySelectionModal: false,
      company_name: companyName,
    });
  }

  edit(callback) {
    let dto = {
      properties: [],
    };

    let propsForEdit = USER_DETAILS_WEBSITE_USER_DATA_CARD;

    propsForEdit.forEach(type => {
      if (this.state[type]) {
        dto.properties?.push({
          name: type,
          value: this.state[type],
        });
      }
    });

    this.props.edit(dto, result => {});
  }

  resetProps() {
    let propsForReset = USER_DETAILS_WEBSITE_USER_DATA_CARD;

    propsForReset.forEach(property => {
      if (this.user[property]) {
        this.setState({ [property]: this.user[property], isEditUser: false });
      }
    });
    return this.setState({ isEditUser: false });
  }

  render() {
    const user = this.props.user;
    return (
      <Card className="user-info-card info-card info">
        <Container>
          {this.state.companySelectionModal && (
            <ModalComponent>
              <CompanySelection onSelect={company => this.onSelectCompany(company)} />
              <div className="d-flex gap-2 mt-2">
                <ButtonComponent
                  style={'ButtonSoftDelete'}
                  onClick={() => {
                    this.setState({ companySelectionModal: false });
                  }}
                >
                  {this.lbl('cancel')}
                </ButtonComponent>
              </div>
            </ModalComponent>
          )}
          <HBox className="align-items-center">
            <h2 className={cn('card-title mb-2', styles.CardTitle)}>{this.lbl('user.details.user_details')}</h2>

            <div
              className={styles.EditIconBlock}
              onClick={() => {
                this.setState(prevState => ({
                  isEditUser: !prevState.isEditCompany,
                }));
              }}
            >
              <EditSquare className={styles.IconEditSquare} />
            </div>
          </HBox>
          <HBox vCenter className={'mb-2'}>
            <List>
              {this.mainInfoFields.map(property => {
                return (
                  <Row key={property}>
                    <Cell>
                      <span style={{ fontWeight: '600' }}>{this.lbl(`website.users.property.${property}`)}: </span>
                    </Cell>
                    <Cell>
                      {this.state.isEditUser && !['company_name', 'company_place'].includes(property) ? (
                        this.input(property)
                      ) : (
                        <span style={{ fontWeight: '600' }}>{user?.[property] ?? ''}</span>
                      )}
                    </Cell>
                  </Row>
                );
              })}

              <br />
              {!this.props.companyDetails && (
                <Row>
                  <Cell>
                    <span style={{ fontWeight: '600' }}>
                      {this.lbl('website.users.property.webuser_registration_type')}:{' '}
                    </span>
                  </Cell>
                  <Cell>
                    {this.state.isEditUser ? (
                      this.dropdown('webuser_registration_type')
                    ) : (
                      <span style={{ fontWeight: '600' }}>{user?.webuser_registration_type ?? ''}</span>
                    )}
                  </Cell>
                </Row>
              )}
            </List>
          </HBox>
          <Permission permission={USERS_CRUD}>
            <HBox className={cn(styles.CheckboxContainer)}>
              {['approved_for_website', 'disapproved_for_website']?.map(property => {
                return (
                  <Checkbox
                    key={property}
                    disabled={this.state?.[property] === '1' || !this.state.isEditUser}
                    checked={this.state[property] === '1' ?? false}
                    smallText={this.props.companyDetails}
                    onChange={() => {
                      const newValue = this.state[property] === '1' ? '0' : '1';
                      if (newValue === '1' && property === 'approved_for_website') {
                        this.setState({ evaluate_for_website: '0', disapproved_for_website: '0' });
                      }
                      if (newValue === '1' && property === 'disapproved_for_website') {
                        this.setState({ evaluate_for_website: '0', approved_for_website: '0' });
                      }
                      this.setState({ [property]: newValue });
                    }}
                  >
                    <strong>{this.lbl(`user.details.${property}`)}</strong>
                  </Checkbox>
                );
              })}
            </HBox>

            {this.financialFieds?.map(property => {
              return (
                <HBox
                  key={property}
                  className={cn(
                    property == 'approved_for_website' || property == 'newsletters' ? styles.CheckboxContainer : '',
                  )}
                >
                  <Checkbox
                    disabled={
                      (property == 'approved_for_website' && this.user?.[property] === '1') || !this.state.isEditUser
                    }
                    checked={this.state[property] === '1' ?? false}
                    smallText={this.props.companyDetails}
                    onChange={() => {
                      const newValue = this.state[property] === '1' ? '0' : '1';
                      if (newValue === '1') {
                        this.setState({ evaluate_for_website: '0' });
                      }
                      this.setState({ [property]: newValue });
                    }}
                  >
                    <strong>{this.lbl(`user.details.${property}`)}</strong>
                  </Checkbox>
                </HBox>
              );
            })}
          </Permission>
          {this.state.isEditUser && (
            <div className="d-flex justify-content-end mt-2">
              <ButtonComponent style={'ButtonSoftDelete'} onClick={this.resetProps.bind(this)}>
                {this.lbl('cancel')}
              </ButtonComponent>
              &nbsp; &nbsp;
              <ButtonComponent style={'ButtonSoftEdit'} onClick={this.edit.bind(this)}>
                {this.lbl('save')}
              </ButtonComponent>
            </div>
          )}
        </Container>
      </Card>
    );
  }
}

WebsiteLoginPermissionsCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,

    edit(dto, callback) {
      dispatch(updateUser(ownProps.user?.id, dto, callback));
    },
    approveWebsiteUserData: () => {
      dispatch(approveWebsiteUserData(ownProps.user?.id));
    },
    disapproveWebsiteUserData: () => {
      dispatch(disapproveWebsiteUserData(ownProps.user?.id));
    },

    togglFinancialProp(property) {
      const newValue = ownProps.user?.[property] === '1' ? '0' : '1';
      const dto = { [property]: newValue };
      dispatch(setUserProperty(ownProps.user?.id, property, newValue));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const WebsiteLoginPermissionsCard = compose(withConnect, withRouter)(WebsiteLoginPermissionsCardComp);
